import { ChatSession, Message } from '../types';

export function getLatestHistorySnapshot(
  currentSessionId: string | null,
  sessions: ChatSession[],
  fallbackMessages: Message[],
): Message[] {
  if (!currentSessionId) {
    return fallbackMessages;
  }

  const session = sessions.find((item) => item.id === currentSessionId);
  if (session?.messages?.length) {
    return session.messages;
  }

  return fallbackMessages;
}
